/**
 * Custom block scripts.
 */

import './blocks/b22-tabs/tabs/index.jsx';
import './blocks/b22-tabs/tabs-inner/index.jsx';
import './blocks/utilities.jsx';
